import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function renderParagraphs(text: string, className: string) {
  return text.split(/\n{2,}/).map((paragraph, index) => (
    <p key={index} className={className}>
      {paragraph}
    </p>
  ));
}

export default function HeroSection() {
  const { t } = useTranslation();
  return (
    <>
      <section className="hero-billboard relative w-full h-[60vh] min-h-[460px] md:h-[82vh] md:min-h-[640px] overflow-hidden">
        <img
          src="/images/generated/residence-hero-x1.jpg"
          alt={t('butlerJob.hero.imgAlt')}
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 hero-overlay"></div>

        <div className="absolute inset-0 flex items-center">
          <div className="relative w-full px-8">
            <div className="max-w-[800px] mx-auto text-center">
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-50 tracking-[0.08em] mb-4">
                {t('butlerJob.hero.title')}
              </h1>
              <p className="section-title-en text-accent-400 text-[15px] md:text-[17px] tracking-[0.12em] mb-6">
                {t('butlerJob.hero.titleEn')}
              </p>
              {renderParagraphs(
                String(t('butlerJob.hero.lead')),
                'text-[15px] md:text-[16px] text-foreground-200/80 tracking-[0.05em] leading-relaxed max-w-[640px] mx-auto',
              )}
            </div>
          </div>
        </div>
      </section>

      <nav aria-label="パンくずリスト" className="bg-background-50 border-b border-background-200">
        <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16 py-3 flex items-center gap-2 text-[13px] text-foreground-500">
          <Link to="/" className="hover:text-accent-600 transition-colors">
            {t('butlerJob.hero.homeLink')}
          </Link>
          <i className="ri-arrow-right-s-line text-foreground-400 text-[12px]"></i>
          <span className="text-foreground-700">{t('butlerJob.hero.currentPage')}</span>
        </div>
      </nav>
    </>
  );
}
